import { useState, useEffect } from 'react';

const DEFAULT_INTERVAL_PING = 4000; //milliseconds
const DEFAULT_FILE_SIZE = '4045312';
const DEFAULT_FILE_URL = 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Illustrating_Wikipedia_brochure.pdf';

export const BYTE = 'byte';
export const KILOBYTE = 'kilobyte';
export const MEGABYTE = 'megabyte';

export const useNetworkMeter = ({ thresholdUnit, pingInterval, measureOnLoad, measureIntervalOnLoad }) => {
    const [measureInterval, setMeasureInterval] = useState(0);
    const [networkSpeed, setNetworkSpeed] = useState(0);

    const calculateResults = ({ startTime, endTime, fileSize }) => {
        const duration = (endTime - startTime) / 1000;

        const bitsLoaded = fileSize * 8;

        const speedBps = (bitsLoaded / duration).toFixed(2);
        const speedKbps = (speedBps / 1024).toFixed(2);
        const speedMbps = (speedKbps / 1024).toFixed(2);

        return { speedBps, speedKbps, speedMbps };
    };

    const saveResults = ({ speedBps, speedKbps, speedMbps }) => {
        const valueByThresholdUnit = {
            [BYTE]: speedBps,
            [KILOBYTE]: speedKbps,
            [MEGABYTE]: speedMbps,
        };

        setNetworkSpeed(valueByThresholdUnit[thresholdUnit]);
    };

    const makeMeasure = () =>
        new Promise((resolve, reject) => {
            const startTime = new Date().getTime();
            const cacheBuster = `?nnn=${startTime}`;

            fetch(`${DEFAULT_FILE_URL}${cacheBuster}`)
                .then(response => {
                    const endTime = new Date().getTime();
                    const fileSize = response.headers.get('content-length') || DEFAULT_FILE_SIZE;
                    const results = calculateResults({ startTime, endTime, fileSize });
                    saveResults(results);
                    resolve(results);
                })
                .catch(err => reject(err));
        });

    const startIntervalMeasure = () => {
        const intervalToSave = setInterval(makeMeasure, pingInterval || DEFAULT_INTERVAL_PING);
        setMeasureInterval(intervalToSave);
    };

    const clearMeasureInterval = () => {
        clearInterval(measureInterval);
    };

    useEffect(() => {
        measureOnLoad && makeMeasure();
        measureIntervalOnLoad && startIntervalMeasure();
    }, []);

    return { makeMeasure, startIntervalMeasure, clearMeasureInterval, networkSpeed };
};
